// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SugarCounter_wrapper__3ug5v"};